import { Link } from 'react-router-dom';
import type { TVSeries } from '@/mocks/tvSeries';

interface TVCardProps {
  series: TVSeries;
  size?: 'normal' | 'large';
}

export default function TVCard({ series, size = 'normal' }: TVCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/article/${series.id}`}
      className="group block"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className={`relative overflow-hidden rounded-lg ${isLarge ? 'aspect-[16/9]' : 'aspect-[3/4]'}`}>
        <img
          src={series.image}
          alt={series.title}
          title={`${series.title} - 窝窝影院免费在线观看`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-0 left-0 right-0 p-3">
            <p className="text-white text-xs leading-relaxed line-clamp-2">{series.description}</p>
            <div className="flex items-center gap-1.5 mt-2">
              <span className="text-primary-400 text-xs font-medium">{series.rating}</span>
              <i className="ri-star-fill text-primary-400 text-xs w-3 h-3 flex items-center justify-center"></i>
            </div>
          </div>
        </div>
        {series.isHot && (
          <span className="absolute top-2 left-2 bg-primary-500 text-white text-xs px-2 py-0.5 rounded-md font-medium whitespace-nowrap">
            热播
          </span>
        )}
        {series.isNew && (
          <span className="absolute top-2 left-2 bg-accent-500 text-white text-xs px-2 py-0.5 rounded-md font-medium whitespace-nowrap">
            新番
          </span>
        )}
        {series.status === '更新中' && !series.isHot && (
          <span className="absolute top-2 left-2 bg-secondary-500 text-white text-xs px-2 py-0.5 rounded-md font-medium whitespace-nowrap">
            更新中
          </span>
        )}
        <div className="absolute top-2 right-2 bg-black/60 backdrop-blur-sm text-white text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
          {series.rating}
        </div>
      </div>
      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
          {series.title}
        </h3>
        <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
          <span>{series.year}</span>
          <span className="text-foreground-300">·</span>
          <span>{series.category}</span>
          <span className="text-foreground-300">·</span>
          <span>共{series.totalEpisodes}集</span>
        </div>
      </div>
    </Link>
  );
}